import { combineReducers } from 'redux';

import dashboard from './dashboard';
import generals from './generals';
import modal from './modal';
import session from './session';
import system from './system'

const rootReducer = combineReducers({
    dashboard,
    generals,
    modal,
    session,
    system
});

export default  rootReducer;